var App = App || {};
App.AuthorCard = (function ($) {
    var NARROW_LAYOUT_MAX_WIDTH = 1200;
    var ARROW_INSET = 20;

    return {
        reposition: reposition
    };

    function reposition(authorCard, columnRightEdge) {
        if (!authorCard.length) {
            return;
        }
        if (isInlineAuthorCard(authorCard)) {
            positionInlineAuthorCard(authorCard, columnRightEdge);
            return;
        }
        if (columnRightEdge !== undefined) {
            shiftLegacyAuthorCard(authorCard, columnRightEdge);
            return;
        }
        if (isNarrowLayout()) {
            var contentColumnRightEdge = getContentColumnRightEdge();
            if (contentColumnRightEdge !== null) {
                shiftLegacyAuthorCard(authorCard, contentColumnRightEdge);
            }
        } else {
            // if we're not in semi-mobile view where right rail goes to the bottom, put
            // cards back where they belong
            authorCard.removeClass('shift-card');
        }
    }

    function isInlineAuthorCard(authorCard) {
        return authorCard.closest('.book-info__author.contributor-inline, .book-info__section-editors .book-info__author').length > 0;
    }

    function isNarrowLayout() {
        return $(window).width() < NARROW_LAYOUT_MAX_WIDTH;
    }

    function getViewportRightEdge() {
        return $(window).width() + window.pageXOffset;
    }

    function getContentColumnRightEdge() {
        var $contentColumn = $('#ContentColumn:visible');
        if (!$contentColumn.length) {
            return null;
        }
        return $contentColumn.position().left + $contentColumn.width();
    }

    function positionInlineAuthorCard(authorCard, columnRightEdge) {
        var trigger = authorCard.siblings('.linked-name')[0];
        var container = authorCard.closest('.book-info__author-list, .chapter__author-list, .section-editors-dropdown-content')[0];
        if (!trigger || !container || !authorCard.hasClass('open')) {
            return;
        }
        var nameLine = getLastLineBounds(trigger);
        if (nameLine === null) {
            return;
        }
        if (columnRightEdge === undefined) {
            columnRightEdge = isNarrowLayout() ? getContentColumnRightEdge() : null;
        }
        if (columnRightEdge !== null) {
            columnRightEdge = Math.min(columnRightEdge, getViewportRightEdge());
        }
        var containerLeft = container.getBoundingClientRect().left;
        var cardWidth = authorCard.outerWidth();
        var overflowsColumn = columnRightEdge !== null && nameLine.left + window.pageXOffset + cardWidth > columnRightEdge;
        var left = overflowsColumn ? nameLine.right - cardWidth : nameLine.left;
        var cardOffsetInContainer = Math.max(0, left - containerLeft);
        authorCard.toggleClass('shift-card', overflowsColumn);
        authorCard.css('left', cardOffsetInContainer);
        aimArrowAtName(authorCard, nameLine, containerLeft + cardOffsetInContainer, cardWidth);
    }

    function aimArrowAtName(authorCard, nameLine, cardLeft, cardWidth) {
        var arrowLeft = Math.min(Math.max(nameLine.left - cardLeft + ARROW_INSET, ARROW_INSET), cardWidth - ARROW_INSET);
        authorCard[0].style.setProperty('--author-card-arrow-left', arrowLeft + 'px');
    }

    function getLastLineBounds(element) {
        var rects = $.makeArray(element.getClientRects()).filter(function (rect) {
            return rect.width > 0;
        });
        if (!rects.length) {
            return null;
        }
        var lastLineTop = Math.max.apply(null, rects.map(function (rect) {
            return rect.top;
        }));
        var lastLineRects = rects.filter(function (rect) {
            return Math.abs(rect.top - lastLineTop) < 1;
        });
        return {
            left: Math.min.apply(null, lastLineRects.map(function (rect) {
                return rect.left;
            })),
            right: Math.max.apply(null, lastLineRects.map(function (rect) {
                return rect.right;
            }))
        };
    }

    function shiftLegacyAuthorCard(authorCard, columnRightEdge) {
        var $authorLinkWrap = authorCard.closest('.al-author-name');
        if (!$authorLinkWrap.length) {
            $authorLinkWrap = authorCard.closest('.al-author-name-more');
        }
        var linkPos = $authorLinkWrap.offset();
        var cardWidth = authorCard.width();
        var authorCardRight = linkPos.left + cardWidth;
        if (authorCardRight > columnRightEdge) {
            authorCard.addClass('shift-card');
        } else if (authorCard.hasClass('shift-card') && linkPos.left + cardWidth < columnRightEdge) {
            authorCard.removeClass('shift-card');
        }
    }
})(jQuery);
